var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrack7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 45,
    viewBox: "0 0 126 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 33.5399V14.5C3 8.14873 8.14873 3 14.5 3H29.7526C32.1117 3 34.333 4.11068 35.7484 5.9979C39.1158 10.4878 44.9106 12.4247 50.3011 10.8623L67.4789 5.88322C73.6803 4.08571 80.27 4.12562 86.4491 5.99809L105.763 11.8508C108.659 12.7284 111.782 12.4633 114.488 11.1099C118.911 8.89842 123.908 12.8462 122.779 17.6608L120.216 28.5974C119.633 31.086 120.019 33.7033 121.296 35.9173C122.856 38.6212 120.905 42 117.783 42H94.2835C90.7814 42 87.4346 40.5544 85.0339 38.0047L72.6306 24.8322C68.173 20.0981 60.2575 22.0126 58.456 28.2605C58.2249 29.0619 57.5931 29.6852 56.7885 29.9054L13.6934 41.6999C12.9656 41.8991 12.2146 42 11.4601 42C6.78771 42 3 38.2123 3 33.5399Z",
    stroke: "currentColor",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrack7);
export default __webpack_public_path__ + "static/media/track7.aa75ee5a.svg";
export { ForwardRef as ReactComponent };